var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconError18 = function SvgAIconError18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.25V9.25",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.5C12.0376 14.5 14.5 12.0376 14.5 9C14.5 5.96243 12.0376 3.5 9 3.5C5.96243 3.5 3.5 5.96243 3.5 9C3.5 12.0376 5.96243 14.5 9 14.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00586 11.25C9.0511 11.25 9.08778 11.2867 9.08778 11.3319",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92578 11.3319C8.92572 11.3102 8.93434 11.2893 8.94971 11.2739C8.96509 11.2586 8.98596 11.2499 9.0077 11.25",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00673 11.4138C8.98498 11.4139 8.96411 11.4053 8.94874 11.3899C8.93336 11.3745 8.92475 11.3537 8.9248 11.3319",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08778 11.3319C9.08778 11.3771 9.0511 11.4138 9.00586 11.4138",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconError18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik05IDYuMjVWOS4yNSIgc3Ryb2tlLXdpZHRoPSIxLjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDE0LjVDMTIuMDM3NiAxNC41IDE0LjUgMTIuMDM3NiAxNC41IDlDMTQuNSA1Ljk2MjQzIDEyLjAzNzYgMy41IDkgMy41QzUuOTYyNDMgMy41IDMuNSA1Ljk2MjQzIDMuNSA5QzMuNSAxMi4wMzc2IDUuOTYyNDMgMTQuNSA5IDE0LjVaIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik05LjAwNTg2IDExLjI1QzkuMDUxMSAxMS4yNSA5LjA4Nzc4IDExLjI4NjcgOS4wODc3OCAxMS4zMzE5IiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNOC45MjU3OCAxMS4zMzE5QzguOTI1NzIgMTEuMzEwMiA4LjkzNDM0IDExLjI4OTMgOC45NDk3MSAxMS4yNzM5QzguOTY1MDkgMTEuMjU4NiA4Ljk4NTk2IDExLjI0OTkgOS4wMDc3IDExLjI1IiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNOS4wMDY3MyAxMS40MTM4QzguOTg0OTggMTEuNDEzOSA4Ljk2NDExIDExLjQwNTMgOC45NDg3NCAxMS4zODk5QzguOTMzMzYgMTEuMzc0NSA4LjkyNDc1IDExLjM1MzcgOC45MjQ4IDExLjMzMTkiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik05LjA4Nzc4IDExLjMzMTlDOS4wODc3OCAxMS4zNzcxIDkuMDUxMSAxMS40MTM4IDkuMDA1ODYgMTEuNDEzOCIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";